import React from 'react';
import type { IconSidebarMenu } from 'commons/modules/SidebarMenu/icon-sidebar-menu';
import { MENU_KEYS } from 'constants/constants';

const FoundsBalancingIcon = ({
  currentImage,
  isExpanded,
  disabled,
  returnPath,
  open,
}: IconSidebarMenu) => {
  const logicOp = () => {
    const currentImg = currentImage === MENU_KEYS.rebalanceFunds;
    const expanded = isExpanded === `panel1${MENU_KEYS.rebalanceFunds}`;
    const path =
      returnPath('/portafolio-fondos/portafolios') ||
      returnPath('/portafolio-fondos/estrategia') ||
      returnPath('/portafolio-fondos/restricciones') ||
      returnPath('/portafolio-fondos/rebalanceo');

    return Boolean(currentImg || (path && !open) || (expanded && open));
  };
  if (disabled && currentImage !== MENU_KEYS.rebalanceFunds)
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" fill="#525067" />
        <path
          d="M29 18C25.69 18 23 20.69 23 24C23 27.31 25.69 30 29 30C32.31 30 35 27.31 35 24C35 20.69 32.31 18 29 18ZM17 20C14.79 20 13 21.79 13 24C13 26.21 14.79 28 17 28C19.21 28 21 26.21 21 24C21 21.79 19.21 20 17 20ZM17 26C15.9 26 15 25.1 15 24C15 22.9 15.9 22 17 22C18.1 22 19 22.9 19 24C19 25.1 18.1 26 17 26Z"
          fill="#757A96"
        />
      </svg>
    );

  if (logicOp())
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" fill="#F4F2F9" />
        <path
          d="M29 18C25.69 18 23 20.69 23 24C23 27.31 25.69 30 29 30C32.31 30 35 27.31 35 24C35 20.69 32.31 18 29 18ZM17 20C14.79 20 13 21.79 13 24C13 26.21 14.79 28 17 28C19.21 28 21 26.21 21 24C21 21.79 19.21 20 17 20ZM17 26C15.9 26 15 25.1 15 24C15 22.9 15.9 22 17 22C18.1 22 19 22.9 19 24C19 25.1 18.1 26 17 26Z"
          fill="#6D46DD"
        />
      </svg>
    );

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" fill="#525067" />
      <path
        d="M29 18C25.69 18 23 20.69 23 24C23 27.31 25.69 30 29 30C32.31 30 35 27.31 35 24C35 20.69 32.31 18 29 18ZM17 20C14.79 20 13 21.79 13 24C13 26.21 14.79 28 17 28C19.21 28 21 26.21 21 24C21 21.79 19.21 20 17 20ZM17 26C15.9 26 15 25.1 15 24C15 22.9 15.9 22 17 22C18.1 22 19 22.9 19 24C19 25.1 18.1 26 17 26Z"
        fill="#F4F2F9"
      />
    </svg>
  );
};

export default FoundsBalancingIcon;
